export const coachesList = {
    GET_LIST_COACHES: "GET_LIST_COACHES",
    GET_LIST_COACHES_SUCCESS : "GET_LIST_COACHES_SUCCESS",
    GET_LIST_COACHES_NULL : "GET_LIST_COACHES_NULL",
    GET_LIST_COACHES_ERROR : "GET_LIST_COACHES_ERROR",
    GET_NEW_COACHES_ON_SCROLL : "GET_NEW_COACHES_ON_SCROLL",
    CLEAR_COACHES_FILTERS: "CLEAR_COACHES_FILTERS",
    CLEAR_COACHES_LIST: "CLEAR_COACHES_LIST"
}